<h2>About My Day</h2>

<p>Enter how much time (in hours) you spent in various locations for the past 24 hours, and any active time (in minutes) for each location.</p>

<div>Examples of activities at different intensity levels:</div>
<ul>
<li>Light: walking &lt; 3 km/hr, light cleaning, cooking</li>
<li>Moderate: walking &gt; 3 km/hr, vacuuming</li>
<li>Vigorous: running</li>
<li>Sedentary: sleeping, sitting, standing</li>
</ul>

<form class="usa-form">
  <table class="usa-table usa-table--borderless">
    <caption class="visuallyhidden" style="position: static">Table for entering information about your daily activities</caption>
    <thead>
      <tr>
        <th scope="col">Microenvironment</th>
        <th scope="col">Total Time Spent<br>(Hours)</th>
        <th *ngFor="let intensity of intensities" scope="col">Activity Level:<br>{{ intensity }}</th>
        <th scope="col">Activity Level:<br>{{ Intensity.sedentary }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let env of envs; index as i">
        <th scope="row">{{ env }}</th>
        <td>
          <label class="usa-label visuallyhidden" for="input-env-{{i}}">{{ env }}</label>
          <input class="usa-input" id="input-env-{{i}}" name="input-env-{{i}}" type="number" [(ngModel)]="userActivity[env]">
        </td>
        <ng-container *ngIf="env != Microenvironment.vehicles">
          <td *ngFor="let intensity of intensities; index as j">
            <label class="usa-label visuallyhidden" for="input-act-{{i}}-{{j}}">{{ env }} / {{ intensity }}</label>
            <input class="usa-input" id="input-act-{{i}}-{{j}}" name="input-act-{{i}}-{{j}}" type="number" [(ngModel)]="userExercise[env][intensity]">
          </td>
          <td>
            {{ sedentaryTime(env) }} minutes
          </td>
        </ng-container>
      </tr>
      <tr>
        <th scope="row">{{ Microenvironment.home }}</th>
        <td>{{ timeSpentIndoorsAtHome() }} hours</td>
        <td *ngFor="let intensity of intensities; index as j">
          <label class="usa-label visuallyhidden" for="input-act-home-{{j}}">{{ Microenvironment.home }} / {{ intensity }}</label>
          <input class="usa-input" id="input-act-home-{{j}}" name="input-act-home-{{j}}" type="number" [(ngModel)]="userExercise[Microenvironment.home][intensity]">
        </td>
        <td>
          {{ sedentaryTime(Microenvironment.home) }} minutes
        </td>
      </tr>
    </tbody>
  </table>
</form>

<p>
  <button class="usa-button" type="button" (click)="save()">Save</button>
  <button class="usa-button usa-button--secondary" type="button" routerLink="/" skipLocationChange>Cancel</button>
</p>
